<template>
  <div class="pa-0">
    <vue-element-loading :active="loading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32" spinner="bar-fade-scale" />
    
    <v-snackbar v-model="showSnackbar" :color="snackbarColor" right bottom>
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <!-- <v-card-title class="elevation-0 px-0 pl-8">
          <span class="itemHeading" style="color: #005f32">LATE ARRIVAL PENALTY</span>
        </v-card-title> -->

        <v-layout wrap justify-start pa-0 pa-xs-0 pa-sm-2 pa-md-5 pa-lg-5 pa-xl-5>
          <v-flex xs12>
            <v-tabs
              v-model="activeTab"
          color="#005f32"
          background-color="transparent"
          class="mb-4"
        >
          <v-tab href="#tab-la">LA Penalty</v-tab>
          <v-tab href="#tab-nm">NM Penalty</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab" style="background-color: transparent;">
          <v-tab-item value="tab-la">
            <v-card class="elevation-2 rounded-lg overflow-hidden">
              <v-card-title class="white--text justify-center py-2" style="background-color: #005f32; font-family: 'KumbhBold' !important; font-size: 14px;">
                LIST OF EXCLUDED MEMBERS FROM LATE ARRIVAL PENALTY
              </v-card-title>

              <v-card-text class="pt-6">
                <v-layout wrap align-center mb-4>
                  <v-flex xs12 sm8>
                    <span class="kumbhRegular" style="font-size: 15px; color: #666;">
                      Excluded members list retrieved successfully
                    </span>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Members"
                      single-line
                      hide-details
                      outlined
                      dense
                      class="rounded-pill mt-2 mt-sm-0"
                      color="#005f32"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-data-table
                  :headers="headers"
                  :items="excludedList"
                  :search="search"
                  class="elevation-0 custom-penalty-table"
                  :items-per-page="15"
                  mobile-breakpoint="0"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="removeMember(item)"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove from Exclude List</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-nm">
            <v-card class="elevation-2 rounded-lg overflow-hidden">
              <v-card-title class="white--text justify-center py-2" style="background-color: #005f32; font-family: 'KumbhBold' !important; font-size: 14px;">
                LIST OF EXCLUDED MEMBERS FROM NM PENALTY
              </v-card-title>

              <v-card-text class="pt-6">
                <v-layout wrap align-center mb-4>
                  <v-flex xs12 sm8>
                    <span class="kumbhRegular" style="font-size: 15px; color: #666;">
                      Excluded members list retrieved successfully
                    </span>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Members"
                      single-line
                      hide-details
                      outlined
                      dense
                      class="rounded-pill mt-2 mt-sm-0"
                      color="#005f32"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-data-table
                  :headers="headers"
                  :items="excludedList"
                  :search="search"
                  class="elevation-0 custom-penalty-table"
                  :items-per-page="15"
                  mobile-breakpoint="0"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="removeMember(item)"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove from Exclude List</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "lateArrivalPenaltyExcludeList",
  data() {
    return {
      loading: false,
      search: "",
      excludedList: [],
      showSnackbar: false,
      snackbarMsg: "",
      snackbarColor: "black",
      headers: [
        { text: "Employee ID", value: "employeeId", align: "start", class: "font-weight-bold" },
        { text: "Name", value: "name", class: "font-weight-bold" },
        { text: "Position", value: "position", class: "font-weight-bold" },
        { text: "Actions", value: "actions", align: "center", sortable: false, class: "font-weight-bold" },
      ],
      activeTab: "tab-la",
    };
  },
  watch: {
    activeTab() {
      this.fetchExcludedList();
    }
  },
  mounted() {
    this.fetchExcludedList();
  },
  methods: {
    fetchExcludedList() {
      this.loading = true;
      const url = this.activeTab === "tab-la" ? "/late-arrival-penalty/config" : "/not-marked-penalty/config";
      axios({
        method: "GET",
        url: url,
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((response) => {
        this.excludedList = response.data.data || [];
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.toast("Failed to load exclude list", "error");
      });
    },
    removeMember(item) {
      if (confirm(`Are you sure you want to remove ${item.name} from the exclude list?`)) {
        this.loading = true;
        const url = this.activeTab === "tab-la" ? `/late-arrival-penalty/config/remove/${item._id}` : `/not-marked-penalty/config/remove/${item._id}`;
        axios({
          method: "DELETE",
          url: url,
          headers: { "x-auth-token": localStorage.getItem("token") },
        })
        .then((response) => {
          if (response.data.status) {
            this.toast("Member removed successfully", "success");
            this.fetchExcludedList();
          } else {
            this.toast(response.data.msg || "Failed to remove member", "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
          this.toast(err.response?.data?.msg || "Failed to remove member", "error");
        });
      }
    },
    toast(msg, type = "success") {
      this.snackbarMsg = msg;
      this.snackbarColor = type === "success" ? "#005f32" : "error";
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
.itemHeading {
  font-family: 'KumbhBold' !important;
  font-size: 22px;
}
.kumbhBold {
  font-family: 'KumbhBold' !important;
}
.kumbhRegular {
  font-family: 'KumbhRegular' !important;
}
.custom-penalty-table >>> thead {
  background-color: #f5f5f5;
}
.custom-penalty-table >>> th {
  font-family: 'KumbhBold' !important;
  font-size: 15px !important;
  color: #000 !important;
  border-bottom: 2px solid #005f32 !important;
}
.custom-penalty-table >>> td {
  font-family: 'KumbhMedium' !important;
  font-size: 15px !important;
  padding: 12px 16px !important;
}
</style>

<style scoped>
.custom-table >>> thead {
  background-color: #f5f5f5;
}
.custom-table >>> th {
  font-family: 'KumbhBold' !important;
  font-size: 14px !important;
  color: #000 !important;
}
.custom-table >>> td {
  font-family: 'KumbhRegular' !important;
  font-size: 14px !important;
}
</style>
